export const loading = state => state.loading;
export const token = state => state.token;
export const username = state => state.username;



// WEBPACK FOOTER //
// ./src/store/getters.js